import { setUser } from '../../../shared/actions/user';

import { TThunkAction } from '../../../shared/types/redux/thunk';
import { IUser } from '../../types/user/user';
import { getUser } from '../../services/getUser';
import { getSubdomain } from '../../selectors';

export function getUserAction(): TThunkAction<Promise<IUser | undefined>> {
  return async (dispatch, getState, context) => {
    const subdomain = getSubdomain(getState());

    const { httpApi, logger } = context;
    const user = await getUser(httpApi, logger, undefined, subdomain);

    dispatch(setUser(user.user));

    return user.user;
  };
}
